import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import type { GetSnippetListApiArg } from '@/__generated/es-api'
import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_SNIPPETS_SERVER } from '@/app/module/user/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

type Query = Omit<GetSnippetListApiArg, 'orgId'>
type QueryOptions = {
  skip?: boolean
}

export const useGetSnippets = (query: Query = {}, options?: QueryOptions) => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const res = esApi.endpoints.getSnippetList.useQuery(
    { orgId: orgId.toString(), ...query },
    {
      skip: !orgId || Boolean(options?.skip),
    },
  )

  useEffect(() => {
    if (!res.error) {
      return
    }

    dispatch(
      createNotification({
        'get-snippets-error': {
          type: 'error',
          message: getErrorMessage(res.error, ERROR_GET_SNIPPETS_SERVER),
        },
      }),
    )
  }, [dispatch, res.error])

  return res
}
